import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GlgSimpleCheckbox, GlgDisabledElementWrapper } from 'SharedComponents'
import {
  EMPTY_CONFIGS_OPTIONS,
  setConfigsOptions,
  selectConfigsOptions,
  isOptionLockedByDependent,
} from '../../reducers/leagues_configs'
import useAvailableConfigOptions from '../../hooks/useAvailableConfigOptions'
import ConfigInfo from './ConfigInfo'


const LeaguesConfigOptions = () => {
  const dispatch = useDispatch()
  const configsOptions = useSelector(selectConfigsOptions)
  const availableConfigOptions = useAvailableConfigOptions()

  const allAvailableSelected = availableConfigOptions.every(option => configsOptions[option.id])

  const handleSelectAllConfigs = React.useCallback(() => {
    if (!allAvailableSelected) {
      const allSelected = Object.fromEntries(availableConfigOptions.map(option => [ option.id, true ]))
      dispatch(setConfigsOptions(allSelected))
    } else {
      dispatch(setConfigsOptions(EMPTY_CONFIGS_OPTIONS))
    }
  }, [ allAvailableSelected, availableConfigOptions, dispatch ])

  const handleConfigChange = React.useCallback((configKey) => {
    const newConfig = structuredClone(configsOptions)
    newConfig[configKey] = !newConfig[configKey]
    dispatch(setConfigsOptions(newConfig))
  }, [ configsOptions, setConfigsOptions, dispatch ])

  const isOptionLocked = React.useCallback((option) => {
    return isOptionLockedByDependent(option.id, configsOptions)
  }, [ configsOptions ])

  return (
    <div>
        <span className={'cls-lcd-grid-header'}>
          <span className={'cls-subtitle-bold'}>
            {window.I18n.t('clone_leagues_sessions.leagues_configs.select_configurations')}
          </span>
          <GlgDisabledElementWrapper>
            <span
              onClick={() => handleSelectAllConfigs()}
              className={'cls-controls-text'}>{window.I18n.t(allAvailableSelected ? 'buttons.unselect_all' : 'buttons.select_all')}
            </span>
          </GlgDisabledElementWrapper>
        </span>
    <div className={'cls-lcd-grid'}>
      {availableConfigOptions.map((option) => (
        <GlgDisabledElementWrapper
          key={option.id}
          disabled={isOptionLocked(option)}>
          <div
            className={'cls-lcd-cell'}
            onClick={() => handleConfigChange(option.id)}
          >
            <GlgSimpleCheckbox className={'cls-lcd-checkbox'} checked={configsOptions[option.id]}/>
            <span className={'cls-lcd-label'}>
              <span className={'cls-lcd-label-text'}>
                {window.I18n.t(`clone_leagues_sessions.leagues_configs.options.${option.id}`)}
              </span>
              {option.withInfo && <ConfigInfo text={window.I18n.t(`clone_leagues_sessions.leagues_configs.options.${option.id}_info`)} />}
            </span>
          </div>
        </GlgDisabledElementWrapper>
      ))}
    </div>
  </div>)
}

export default LeaguesConfigOptions
